import { Connection, Primitive } from "../../types/TransactionTemplate.types";

export function getDescendantIds(
  sourceId: string,
  primitives: Primitive[],
  connections: Connection[],
): Set<string> {
  const result = new Set<string>();
  const queue = [sourceId];

  while (queue.length > 0) {
    const current = queue.shift()!;
    const outgoing = connections.filter((c) => c.from === current);
    for (const conn of outgoing) {
      if (!result.has(conn.to)) {
        result.add(conn.to);
        queue.push(conn.to);
      }
    }
  }

  return result;
}

export function saveCollapsed(txId: number, collapsed: Set<string>) {
  localStorage.setItem(
    `collapsed_tx_${txId}`,
    JSON.stringify([...collapsed]),
  );
}

export function loadCollapsed(txId: number): Set<string> {
  try {
    const raw = localStorage.getItem(`collapsed_tx_${txId}`);
    if (!raw) return new Set();
    return new Set(JSON.parse(raw));
  } catch {
    return new Set();
  }
}